export default __webpack_public_path__ + "static/media/titleXmas.c1768ec2.png";